import { Component, OnInit, HostListener, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { JsonService, LoadingService, GlobalService, LoggerService } from '../_services';
import { DialogService } from '../dialog/dialog.service';
import { StringSwitchService } from '../_helpers/string-switch.service';
import { TranslateService } from '@ngx-translate/core';
import { UnrecognizedItem, Group, PrescriptionResponse, Prescription, PrescriptionContent } from '../_models';
import { Medico } from '../_models/medico.model';
import { Instituicao } from '../_models/instituicao.model';
import { HttpParams } from '@angular/common/http';
import { PrescriptionValidacaoPendentesItemResponse } from '../_models/prescription-validacao-pendentes-item-response.model';
import { ValidacaoPrescriptionPendenteItem } from '../_models/prescription-validacao-pendentes-item.model';
import { PrescriptionPendingConteudoContent } from '../_models/prescription-validacao-conteudo-content.model';
import { nomeInstituicaoFinal, nroDoCadastro } from './interacao-revisor';


@Component({
  selector: 'app-detalhe-pending-issues',
  templateUrl: './detalhe-pending-issues.component.html',
  styleUrls: ['./detalhe-pending-issues.component.scss'],
  host: {
    'style': 'font-size: 0.86em;'
  }
})

export class DetalhePendingIssuesComponent implements OnInit {

  @ViewChildren(MatAutocompleteTrigger) autocompleteTriggers!: QueryList<MatAutocompleteTrigger>;
  @ViewChildren('especialidadeInput') especialidadeInputs!: QueryList<ElementRef>;
  @ViewChildren('produtoInput') produtoInputs!: QueryList<ElementRef>;
  @ViewChild('salvarButton') salvarButton!: ElementRef;
  @ViewChild('salvarButton1') salvarButton1!: ElementRef;

  public isVisibleDiagnostico: boolean = false;
  public isVisibleNomeMedico: boolean = false;
  public isVisibleEnderecoMedico: boolean = false;
  public isVisibleInstituicao: boolean = false;
  public isVisibleLocalidade: boolean = false;
  public isVisibleEnderecoinstituicao: boolean = false;
  public isVisibleEspecialidadeMedico: boolean = false;
  public isVisibleProduto: boolean = false;
  public codigoPaisMaestro: string = '';
  public codigoRegiaoMaestro: string = '';

  public isInstValidado: boolean = false;
  public isDocValidado: boolean = false;
  public isProdValidado: boolean = false;
  public mostrarPendencias: boolean = false;

  form!: FormGroup;
  thisItem!: ValidacaoPrescriptionPendenteItem;
  listImageQuality: any[] = [];
  listaRegiao: any[] = [];
  filtro: any = {};
  historico = '';
  crmFiltrado: string[] = [];
  nomeMedicoFiltrado: string[] = [];
  especialidadeFiltrado: string[] = [];
  produtoFiltrado: string[] = [];
  posologiaFiltrado: string[] = [];
  infoNotRecognizedOptions: UnrecognizedItem[] = [];
  infoNotRecognizedFiltred: UnrecognizedItem[] = [];
  filteredOptions!: Observable<string[]>;

  // flags
  isModalOpen = false;
  isModal1Open = false;
  temHistorico = false;
  temAnterior = false;
  canDestroy = false;
  doShortcutActive = true;
  isRefused = false;
  isSmartCase = true;
  isImageCollapsed = false;
  isCancelAction = false;
  public conteudoIndisponivel = false;

  // dados receita
  uid = '';
  regiaoId = '';
  id_datacapture7 = '';
  status = '';
  pais = '';
  paisName = '';
  data_de_leitura = '';
  revisado: string | null = null;
  data_de_revisao = '';
  blobImage: any = 'loading.gif';
  pdv = '';
  regiao = '';
  groupId = '';
  groupName = '';
  filenameText = '';

  readonly opcoesInfoNotRecognized = [
    "Dados do médico", "Dados da instituição", "Dados do produto"
  ];

  get podeConfirmarRevisao(): boolean {
    const instOk = !this.isVisibleInstituicao || this.isInstValidado;
    const docOk = !this.isVisibleNomeMedico || this.isDocValidado;
    const prodOk = !this.isVisibleProduto || this.isProdValidado;
    return instOk && docOk && prodOk;
  }

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private json: JsonService,
    private dialog: DialogService,
    private logger: LoggerService,
    private loading: LoadingService,
    public global: GlobalService,
    private stringSwitch: StringSwitchService
  ) {}

  // ------------ Lifecycle -----------------
  ngOnInit(): void {
    const routeState = history.state;
    this.filtro = routeState?.filtro ?? this.getLocalStorageJSON('filtro') ?? {};
    //this.filtro.status = 'P'; // força status P para pending issues
    this.subscribeToDialogClose();
    this.loadNotRecognized();
    this.atualizarImageQuality();

    this.isInstValidado = false;
    this.isDocValidado = false;
    this.isProdValidado = false;
    this.mostrarPendencias = false;

    this.route.paramMap.subscribe(params => {
      this.loading.show();
      const uid = params.get('uid');
      const regiaoId = params.get('regiao');

      if (uid && regiaoId) {
        this.uid = uid;
        this.regiaoId = regiaoId;
        localStorage.setItem('prescriptionId', this.uid);
        localStorage.setItem('regionId', this.regiaoId);
        this.getRegionAndPrescriptionData();
      } else {
        this.router.navigate(['/receitas-pending-issues']);
      }
    });
  }

  // ------------ Helpers -----------------
  private getLocalStorageJSON<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }
  toggleCollapsedImage() { this.isImageCollapsed = !this.isImageCollapsed; }
  back() { this.location.back(); }
  backSpace() { this.router.navigate(['/receitas-pending-issues']); }
  switchString(v: string) { return this.stringSwitch.switchString(v); }

  // ✅ Autocomplete Recusa (filtra por code ou name)
  private normalize(v: any): string {
    return (v ?? '').toString().trim().toLowerCase();
  }

  private filterNotRecognized(term: any): UnrecognizedItem[] {
    const t = this.normalize(term);
    if (!t) return this.infoNotRecognizedOptions.slice();

    return this.infoNotRecognizedOptions.filter((x: any) => {
      const code = this.normalize(x.code);
      const name = this.normalize(x.name);
      return code.includes(t) || name.includes(t);
    });
  }

  private setupNotRecognizedAutocomplete(): void {
    const ctrl = this.form?.get('notReconize');
    if (!ctrl) return;

    // lista inicial
    this.infoNotRecognizedFiltred = this.filterNotRecognized(ctrl.value);

    // filtra ao digitar
    ctrl.valueChanges.subscribe(value => {
      this.infoNotRecognizedFiltred = this.filterNotRecognized(value);
    });
  }

  // ------------ Dialog / API -----------------
  private subscribeToDialogClose() {
    this.dialog.onClose$.subscribe(id => {
      ({ changeNext: () => this.nextPrescription(),
         aviso: () => this.loading.hide(),
         avisoEnd: () => this.router.navigate(['/receitas-pending-issues'])
      }[id]?.());
    });
  }
  private chamarApiAoSair(id: string | null = null) {
    if (!this.canDestroy) return;
    this.json.unlockAllPage().subscribe({ error: e => this.logger.error('unlockAllPage', e) });
    if (id) this.userLog(id, false);
  }

  private getRegionAndPrescriptionData() {
    // Garante que a região seja carregada antes dos dados da prescrição
    this.json.getRegiaoPorId(this.regiaoId).subscribe({
      next: regionResp => {
        this.listaRegiao = [regionResp]; // Reseta e define a nova região
        this.codigoRegiaoMaestro = regionResp?.regionCode || '';
        this.getJsonData(this.uid); // Agora busca os dados da prescrição
      },
      error: erro => {
        this.logger.error('Erro ao carregar região', erro);
        this.loading.hide();
        this.dialog.abrirDialog('aviso', this.translate.instant('Error') + '!', this.translate.instant('Não foi possível carregar os dados da região.'));
      }
    });
  }

  // ------------ CRUD Receita -----------------
  private getJsonData(uid: string) {
    this.resetAllContent();
    this.confereBackID();
    this.json.lockPageRead(uid).subscribe({
      next: resp => {
        // username fica em sessionStorage desde o login novo (5b1602d); localStorage retornava null
        // e fazia toda receita parecer "acessada por outro usuário". Comparação case-insensitive:
        // o SQL não diferencia caixa no email, o !== do JS sim.
        if (resp.lockedBy && resp.lockedBy.toLowerCase() !== sessionStorage.getItem('username')?.toLowerCase()) {
          this.dialog.abrirDialog('aviso', this.translate.instant('Aviso') + '!', this.translate.instant('Receita sendo acessada por outro usuário'));
          this.router.navigate(['/receitas-pending-issues']);
        } else if (resp.lockedBy) {
          // Lock já é do próprio usuário (F5/reentrada) — carrega direto
          this.codigoRegiaoMaestro = this.listaRegiao[0]?.regionCode || '';
          this.getJsonDataGetItem(uid);
        } else {
          // Sem lock — cria primeiro e só carrega após confirmação (evita carga dupla e edição sem lock)
          this.codigoRegiaoMaestro = this.listaRegiao[0]?.regionCode || '';
          this.createLock(uid);
        }
      },
      error: e => this.logger.error('lockPageRead', e)
    });
  }

  private createLock(uid: string) {
    const fd = new FormData();
    fd.append('status', '1');
    fd.append('prescriptionId', uid);
    this.json.lockPageCreate(fd).subscribe({
      next: resp => {
        // Backend responde 200 com success=false quando a receita está em uso por outro
        // usuário ou não foi encontrada — respeitar em vez de abrir a tela mesmo assim
        if (resp && resp.success === false) {
          this.dialog.abrirDialog('aviso', this.translate.instant('Aviso') + '!', resp.message || this.translate.instant('Receita sendo acessada por outro usuário'));
          this.loading.hide();
          this.router.navigate(['/receitas-pending-issues']);
          return;
        }
        this.getJsonDataGetItem(uid);
      },
      error: e => this.logger.error('lockPageCreate', e)
    });
    this.userLog(uid, true);
  }

  // Receitas que a IA não conseguiu ler ficam com `conteudo` vazio/inválido (Status "P").
  // Sem esse fallback, o JSON.parse (ou o acesso a campos dentro de buildForm) quebra dentro
  // do next do subscribe e a tela trava no loading para sempre — precisa abrir com form vazio.
  private parseConteudo(raw: string | null | undefined): PrescriptionPendingConteudoContent {
    const conteudoVazio: PrescriptionPendingConteudoContent = {
      dataReceita: '',
      imageQuality: '',
      notReconize: '',
      anonimizada: false,
      produto: [],
      medico: {} as Medico,
      instituicao: {} as Instituicao,
      diagnostico: []
    };

    if (!raw) {
      this.conteudoIndisponivel = true;
      return conteudoVazio;
    }

    try {
      const parsed = JSON.parse(raw);
      if (!parsed) {
        this.conteudoIndisponivel = true;
        return conteudoVazio;
      }
      if (this.isConteudoVazio(parsed)) {
        this.conteudoIndisponivel = true;
      }
      return parsed;
    } catch (e) {
      this.logger.error('parseConteudo', e);
      this.conteudoIndisponivel = true;
      return conteudoVazio;
    }
  }

  // Espelha IsArchiveDtoEmpty (PrescriptionService.cs) — quando a IA não lê nada, o backend
  // grava um JSON válido só com arrays/campos vazios (não uma string vazia), então o parse
  // acima funciona normalmente e precisa dessa checagem semântica pra acender o aviso.
  private isConteudoVazio(c: PrescriptionPendingConteudoContent): boolean {
    if (!c) return true;

    if ((c.dataReceita ?? '').trim() ||
        (c.imageQuality ?? '').trim() ||
        (c.produto?.length ?? 0) > 0 ||
        (c.diagnostico?.length ?? 0) > 0) {
      return false;
    }

    const medicos: any[] = Array.isArray(c.medico) ? c.medico : (c.medico ? [c.medico] : []);
    const medicoTemDados = medicos.some((m: any) =>
      (m?.nome ?? '').trim() || (m?.matricula ?? '').trim() || (m?.rua ?? '').trim() ||
      (m?.numeroEndereco ?? '').trim() || (m?.email ?? '').trim() || (m?.localidade ?? '').trim() ||
      (m?.codigoPostal ?? '').trim() || (m?.especialidade?.length ?? 0) > 0 || (m?.telefone?.length ?? 0) > 0
    );
    if (medicoTemDados) return false;

    const inst: any = Array.isArray(c.instituicao) ? c.instituicao[0] : c.instituicao;
    const instTemDados = !!inst && (
      (inst.nomeInstituicao ?? '').trim() || (inst.rua ?? '').trim() || (inst.numeroEndereco ?? '').trim() ||
      (inst.email ?? '').trim() || (inst.localidade ?? '').trim() || (inst.codigoPostal ?? '').trim() ||
      (inst.telefone?.length ?? 0) > 0
    );
    if (instTemDados) return false;

    return true;
  }

  private getJsonDataGetItem(uid: string) {
    this.doShortcutActive = true;
    this.json.readValidacaoPrescriptionPendentes(uid).subscribe({
      next: (resp: PrescriptionValidacaoPendentesItemResponse) => {
        this.thisItem = resp.prescription;
        const conteudo = this.parseConteudo(this.thisItem.conteudo);
        this.readCountryVisibleFieldsPrescription(this.thisItem['pais']);
        this.buildForm(conteudo);
        this.lockPageCreate(uid);
        this.userLog(uid, true);
        this.loadGroupName(this.thisItem.groupCountryRegionId);
        this.loadImage(uid);
      },
      error: e => this.logger.error('getItem', e)
    });
  }

  private lockPageCreate(uid: string) {
    const fd = new FormData();
    fd.append('status', '1'); fd.append('prescriptionId', uid);
    this.json.lockPageCreate(fd).subscribe({
      next: resp => {
        // Receita em uso por outro usuário (ex.: colisão na transição para a próxima) — avisa e volta
        if (resp && resp.success === false) {
          this.dialog.abrirDialog('aviso', this.translate.instant('Aviso') + '!', resp.message || this.translate.instant('Receita sendo acessada por outro usuário'));
          this.loading.hide();
          this.router.navigate(['/receitas-pending-issues']);
          return;
        }
        this.canDestroy = true; this.setItemData(); this.loading.hide();
      },
      error: e => this.logger.error('lockPageCreate', e)
    });
  }

  private setItemData() {
    const i = this.thisItem;
    this.filenameText = i.filename;
    this.uid = i.prescriptionId
    this.regiaoId = i.regiao;
    //this.id_datacapture7 = i.aiDataCaptureid;
    this.status = this.filtro?.status || i.status;
    this.groupId = i.grupoId; 
    this.pais = i.pais; this.readCountry(this.pais);
    this.data_de_leitura = i.dataLeitura; 
    this.revisado = i.revisado; this.data_de_revisao = i.dataRevisao;
    //this.historico = i.historicoConteudo; this.temHistorico = !!this.historico?.length;
    this.pdv = i.pdv;
    this.regiao = i.regiao;
    //this.isSmartCase = !(i.status === 'W' || i.status === 'w');
  }

  private buildForm(c: PrescriptionPendingConteudoContent) {

    let diagnosticos = (c.diagnostico?.length ?? 0) ? c.diagnostico : ['', ''];
    if (diagnosticos.length === 1) diagnosticos.push('');

    this.form = this.fb.group({
      dataReceita: [c.dataReceita],
      imageQuality: [this.thisItem.imageQuality ?? 'Legivel'],
      notReconize: [''],
      anonimizada: [c.anonimizada ?? false],
      produto: this.fb.array((c.produto ?? []).map(p => this.createProduto(p))),
      medico: this.createMedico({
        ...(Array.isArray(c.medico) ? c.medico[0] : c.medico),
        validMed: this.thisItem?.validMed,
        conteudoMed: this.thisItem?.conteudoMed
      }),
        instituicao: this.createInstituicao({
          ...(Array.isArray(c.instituicao) ? c.instituicao[0] : c.instituicao),
          validInst: (this.thisItem as any)?.validInst,
          conteudoInst: (this.thisItem as any)?.conteudoInst
        }),
        diagnostico: this.fb.array(diagnosticos.map(d => new FormControl(d))),
    });

    // Aplicar status de validação médico (sem alterar inputs de usuário)
    const medicoGroup = this.form.get('medico');
    if (medicoGroup) {
      medicoGroup.patchValue({
        validMed: this.thisItem?.validMed ?? false,
        ConteudoMedFiltro: this.thisItem?.conteudoMed ?? []
      });
    }

      // Aplicar status de validação instituição (sem alterar inputs de usuário)
      const instituicaoGroup = this.form.get('instituicao');
      if (instituicaoGroup) {
        instituicaoGroup.patchValue({
          validInst: (this.thisItem as any)?.validInst ?? false,
          ConteudoInstFiltro: this.parseConteudoFiltro((this.thisItem as any)?.conteudoInst)
        });
      }

    // ✅ Corrigido: notReconize deve ser string, e o backend guarda array
    const saved = JSON.parse(this.thisItem.infoNotRecognized ?? '[]');
    this.form.patchValue({
      notReconize: Array.isArray(saved) ? (saved[0] ?? '') : (saved ?? '')
    });

    // ✅ Ativa o filtro reativo do autocomplete (form já existe)
    this.setupNotRecognizedAutocomplete();
  }

  private loadGroupName(id: string) {
    this.json.getGroupList().subscribe({
      next: (groups: Group[]) => this.groupName = groups.find(g => g.id === id)?.name || '',
      error: e => this.logger.error('getGroupList', e)
    });
  }

  private loadImage(uid: string) {
    this.json.getImageItem(uid).subscribe({
      next: b => this.blobImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(b)),
      error: e => this.logger.error('getImageItem', e)
    });
  }

  public irHistorico(): void {
    this.router.navigate(['/historico', this.uid]);
  }

  // ------------ Save -----------------
  ok() {
    this.isCancelAction = false;
    this.isRefused = this.form.get('imageQuality')?.value === 'Recusada';
    if (this.form.invalid && this.isRefused === false) {
      this.dialog.abrirDialog('aviso', this.translate.instant('Aviso') + '!', this.translate.instant('Por favor, preencha todos os campos requeridos.'));
      this.form.markAllAsTouched();
      return;
    }

    if (!this.isRefused && !this.podeConfirmarRevisao) {
      this.mostrarPendencias = true;

      const faltantes = [];
      if (this.isVisibleInstituicao && !this.isInstValidado) faltantes.push(this.translate.instant('Instituição') + ' (' + this.translate.instant('Nome') + ')');
      if (this.isVisibleNomeMedico && !this.isDocValidado) faltantes.push(this.translate.instant('Médico') + ' (' + this.translate.instant('Nome') + ')');
      if (this.isVisibleProduto && !this.isProdValidado) faltantes.push(this.translate.instant('Produto') + ' (' + this.translate.instant('Nome') + ')');

      let msg = this.translate.instant('Existem itens não verificados: ');
      if (faltantes.length === 1) {
        msg += faltantes[0];
      } else if (faltantes.length > 1) {
        const ultimo = faltantes.pop();
        msg += faltantes.join(', ') + ' ' + this.translate.instant('e') + ' ' + ultimo;
      }
      this.dialog.abrirDialog('aviso', this.translate.instant('Atenção') + '!', msg + '.');
      return;
    }

    this.mostrarPendencias = false;
    this.doShortcutActive = false; this.isModalOpen = true;
    setTimeout(() => this.salvarButton?.nativeElement.focus(), 0);
  }

  cancelar() {
    this.isCancelAction = true;
    this.doShortcutActive = false; this.isModalOpen = true;
  }

  saveChanges() {
    this.loading.show();
    const v = { ...this.form.getRawValue() };

    if (v.produto && Array.isArray(v.produto)) {
      v.produto.forEach((p: any) => {
        if (p.is_manual) {
          // Produto manual: "nome" e o que o revisor digitou (nao existe leitura da IA aqui
          // pra preservar). Preenche retorno_produto tambem com esse valor quando ainda vazio,
          // pra qualquer consumidor que espere o campo de retorno preenchido.
          p.retorno_produto = p.retorno_produto || p.nome;
        }
        // nome_produto_original ja preserva o que a IA leu (setado uma unica vez em
        // createProduto/createProduto do pai, nunca reescrito aqui) — "nome" passa a refletir
        // a decisao da revisao (retorno_produto quando houver, senao fica como esta), mesma
        // regra que ja valia so pra nome_produto_salvo.
        p.nome = p.retorno_produto || p.nome;
        p.nome_produto_salvo = p.retorno_produto || p.nome;
      });
    }
    
    // Atualiza o nome do médico com o valor de retorno_medico, se existir, e garante matrícula preenchida
    if (v.medico) {
      if (v.medico.retorno_med || v.medico.retorno_medico) {
          v.medico.nome = v.medico.retorno_med || v.medico.retorno_medico;
      }
      if(!v.medico.matricula) {
        v.medico.matricula = v.medico.retorno_matricula || v.medico.retorno_matricula1 || v.medico.retorno_matricula2 || '';
      }

      v.medico.nome_medico_salvo = v.medico.retorno_med || v.medico.nome || '';
      v.medico.matricula1_salvo = v.medico.retorno_matricula || v.medico.matricula || '';
      v.medico.matricula2_salvo = v.medico.retorno_matricula1 || '';
      v.medico.matricula3_salvo = v.medico.retorno_matricula2 || '';
      v.medico.especialidade1_salvo = v.medico.retorno_esp1 || (v.medico.especialidade ? v.medico.especialidade[0] : '') || '';
      v.medico.especialidade2_salvo = v.medico.retorno_esp2 || (v.medico.especialidade ? v.medico.especialidade[1] : '') || '';
      v.medico.especialidade3_salvo = v.medico.retorno_esp3 || (v.medico.especialidade ? v.medico.especialidade[2] : '') || '';
      v.medico.endereco_salvo = v.medico.retorno_direccion || v.medico.rua || '';
      v.medico.localidade_salvo = v.medico.retorno_localid || v.medico.localidade || '';
      v.medico.nro_medico = nroDoCadastro(v.medico.interaccion_del_usuario, v.medico.retorno_nro_medico, v.medico.nro_medico);
    }

    // O CSV lê instituicao.nro_instit; sem copiar o retorno, pesquisa e instituição válida saem sem número.
    if (v.instituicao) {
      v.instituicao.nro_instit = nroDoCadastro(v.instituicao.interaccion_del_usuario, v.instituicao.retorno_nro_instit, v.instituicao.nro_instit);
    }

     // "nomeInstituicao" passa a refletir o nome validado (retorno_nome), mesma regra de médico e produto: escolha do
     // revisor (ambiguidade, pesquisa, digitação) ou, sem interação, instituição validada pelo Maestro.
     // nome_instituicao_original ja preserva o que a IA leu (setado uma unica vez em createInstituicao). "Nao
     // encontrada" e instituição sem validação ficam com o nome atual (retorno_nome e so o 1o candidato).
      if (v.instituicao) {
        v.instituicao.nomeInstituicao = nomeInstituicaoFinal(
          v.instituicao.nomeInstituicao, v.instituicao.retorno_nome, v.instituicao.interaccion_del_usuario, v.instituicao.validInst);
      }

     // Atualiza o nome da instituição com o valor de retorno_nome, se existir, e garante endereço preenchido
      if (v.instituicao && v.instituicao.retorno_nome && !v.instituicao.nomeInstituicao) {
        v.instituicao.nomeInstituicao = v.instituicao.retorno_nome; 
        if(!v.instituicao.rua || !v.instituicao.localidade || !v.instituicao.codigoPostal) {
          v.instituicao.rua = v.instituicao.retorno_rua ?? '';
          v.instituicao.localidade = v.instituicao.retorno_cidade ?? '';
          v.instituicao.codigoPostal = v.instituicao.retorno_cep ?? '';
        }
      }   

     v.infoNotRecognized = (v.infoNotRecognized || [])
      .map((c: boolean, i: number) => c ? this.opcoesInfoNotRecognized[i] : null).filter(Boolean);

    this.closeModal(); this.closeModal1();

    const fd = new FormData();
    fd.append('id', this.uid);
    fd.append('conteudo', JSON.stringify({ ...v, infoNotRecognized: undefined }));
    fd.append('imageQuality', this.form.get('imageQuality')?.value);
    fd.append('infoNotRecognized', JSON.stringify([this.form.get('notReconize')?.value])); // string (name)
    fd.append('anonimizada', this.form.get('anonimizada')?.value);

    this.json.sendItem(fd).subscribe({
      next: () => { this.isModal1Open = true;
         setTimeout(() => this.salvarButton1?.nativeElement.focus(), 200);
        
         let history = JSON.parse(localStorage.getItem('listHistory') || '[]');
         if (Array.isArray(history) && history.length > 1) {
            history = history.filter((h: any) => h.id !== this.uid); // Remove todas as entradas da receita atual
            history.pop(); // Remove a entrada atual
            const backEntry = history.at(-1); // Pega a entrada anterior  
            localStorage.setItem('listHistory', JSON.stringify(history)); // Salva o histórico menor
         }
      },
      error: e => {
        this.logger.error('sendItem', e);
        this.loading.hide();
        // GroupController/PrescriptionController devolvem BadRequest(ex.Message) — corpo é a string crua, não { message }.
        const backendMsg = typeof e?.error === 'string' ? e.error : e?.error?.message;
        this.dialog.abrirDialog('aviso', this.translate.instant('Erro') + '!', backendMsg || this.translate.instant('Não foi possível salvar a revisão.'));
      }
    });
  }

  // ------------ Navegação -----------------
  nextPrescription() {
    this.loading.show(); this.isModal1Open = false; this.userLog(this.uid, false);
    let params = new HttpParams(), onReview = false;
    Object.entries(this.filtro).forEach(([k, v]) => {
      if (k === 'regiao') params = params.append('region', v as string);
      else params = params.append(k, v as string);
    });
    params = params.append('onReview', onReview).append('id', this.uid).append('PageNumber', '1').append('pageSize', '1');
    this.json.getNextPagePrescriptionsPendentes(params).subscribe({
      next: (r) => {
        // Garante que a receita atual seja destravada (unlock) independentemente de haver uma próxima ou não
        this.chamarApiAoSair();

        if (r.isNull || !r.prescription) {
          this.loading.hide();
          this.dialog.abrirDialog('avisoEnd', this.translate.instant('Aviso') + '!', this.translate.instant('Não há próxima receita para analisar.'));
          return;
        }
        
        const nextId = r.prescription.id;
        const nextRegionId = r.prescription.regiao;
        this.router.navigate(['/receita-pending-issues', nextId, nextRegionId]);
      },
      error: e => {
        this.logger.error('getNextPagePrescriptionsPendentes', e);
        // GroupController devolve BadRequest(ex.Message) — corpo é a string crua, não { message }.
        const backendMsg = typeof e?.error === 'string' ? e.error : e?.error?.message;
        const msg = backendMsg || this.translate.instant('Sessão expirada.');
        this.dialog.abrirDialog('aviso', this.translate.instant('Informação') + '!', msg);
        this.loading.hide();
      }
    });
  }

  prescriptionBack() {
    this.userLog(this.uid, false);
    let history = JSON.parse(localStorage.getItem('listHistory') || '[]');
    if (Array.isArray(history) && history.length > 1) {
      history.pop(); // Remove a entrada atual
      const backEntry = history.at(-1); // Pega a entrada anterior
      localStorage.setItem('listHistory', JSON.stringify(history)); // Salva o histórico menor

      if (backEntry && backEntry.id && backEntry.regionId) {
        // Apenas navega. O ngOnInit cuidará do resto.
        this.router.navigate(['/receita-pending-issues', backEntry.id, backEntry.regionId]);
      }
    } else {
      this.dialog.abrirDialog('aviso', this.translate.instant('Aviso') + '!', this.translate.instant('Não há receita anterior no histórico de navegação.'));
    }
  }

  // ------------ Auxiliares -----------------
  resetAllContent() {
    this.temHistorico = false;
    this.blobImage = 'loading.gif';
    this.isInstValidado = false;
    this.isDocValidado = false;
    this.isProdValidado = false;
    this.mostrarPendencias = false;
    this.conteudoIndisponivel = false;
    this.form?.reset();
  }
  readCountry(id: string) {
    this.json.readCountry(id).subscribe({
      next: r => this.paisName = r.name,
      error: e => this.logger.error('readCountry', e)
    });
  }
  getRegionName(id: string) {
    return this.listaRegiao[0]?.name || 'Región no encontrada';
  }
  
  confereBackID() {
    // Usa um histórico de objetos para guardar id e regiao
    const history = JSON.parse(localStorage.getItem('listHistory') || '[]');
    if (Array.isArray(history)) {
      const lastEntry = history.at(-1);
      if (!lastEntry || lastEntry.id !== this.uid) {
        history.push({ id: this.uid, regionId: this.regiaoId });
      }
      localStorage.setItem('listHistory', JSON.stringify(history));
      this.temAnterior = history.length >= 2;
    }
  }
  async userLog(id: string, entry: boolean) {
    const fd = new FormData(); fd.append('isEntry', String(entry)); fd.append('prescriptionId', id);
    this.json.userLog(fd).subscribe({ error: e => this.logger.error('userLog', e) });
  }

  loadNotRecognized() {
    this.json.getUnrecognizedItems().subscribe({
      next: r => {
        this.infoNotRecognizedOptions = r;
        this.infoNotRecognizedFiltred = r;

        // ✅ Se o form já existe, re-aplica o filtro com base no valor atual
        if (this.form) this.setupNotRecognizedAutocomplete();
      },
      error: e => this.logger.error('getUnrecognizedItems', e)
    });
  }

  async atualizarImageQuality() {
    this.listImageQuality = await this.json.getImageQuality().toPromise();
  }

  // ------------ Form Builders -----------------
  get diagnosticos() {
    return this.form.get('diagnostico') as FormArray;
  }
  get produtos() {
    return this.form.get('produto') as FormArray;
  }
  createProduto(d: any = {}): FormGroup {
    const retorno_api = d.retorno_api || {
      conteudoProd: [],
      validProd: false,
      conteudoProdFiltro: []
    };

    const ConteudoProdFiltro = (retorno_api.conteudoProd || []).map((p: any) => this.formatRetornoProduto(p));
    const raizMaestro = this.formatRetornoProduto(retorno_api?.conteudoProd?.[0]);

    return this.fb.group({
      nome: [d.nome || ''],
      posologia: [d.posologia || ''],
      motivo_exclusao_produto: [d.motivo_exclusao_produto || ''],
      retorno_api: [retorno_api],
      retorno_produto: [raizMaestro],
          ConteudoProdFiltro: [ConteudoProdFiltro],
          is_manual: [d.is_manual ?? false],
          interaccion_del_usuario: [d.interaccion_del_usuario || ''],
          nome_produto_original: [d.nome_produto_original || d.nome || ''],
          nome_produto_salvo: [d.nome_produto_salvo || ''],
          nro_presen: [d.nro_presen || '']
    });
  }

  // Precisa ser IDENTICO ao formatRetornoProduto do product-form-pending.component.ts —
  // ver comentario la para o motivo (mismatch de formato quebra silenciosamente a busca de
  // nro_presen ao selecionar item da ambiguidade).
  private formatRetornoProduto(prod?: any): string {
    if (!prod) return '';

    const campos = [
      prod.RAIZ_MAESTRO,
      prod.CONCENTRACION_MAESTRO,
      prod.FORMAF_MAESTRO,
      prod.DESC_EXTENDIDA_MAESTRO
    ];

    return campos.filter(Boolean).join(' ').replace(/'/g, '') || '';
  }
  createMedico(d: any = {}) {
    // Garante extração limpa para arrays, propriedades com índice '0' por causa do spread, ou objetos diretos
    const medData = d['0'] || d[0] || d || {};
    const validMed = d.validMed ?? medData.validMed ?? false;
    const conteudoMed = d.conteudoMed ?? medData.conteudoMed;

    const tels = [...(medData.telefone || []), '', ''].slice(0, 2);
    const esp = (medData.especialidade?.length ? medData.especialidade : ['']).slice(0, 4);
    
    const filter = this.parseConteudoFiltro(conteudoMed);
    const firstMatch = filter[0] || {};

    return this.fb.group({
      nome: [medData.nome],
      matricula: [medData.matricula],
      email: [medData.email],
      cdgCiudad: [medData.cdgCiudad],
      rua: [medData.rua],
      localidade: [medData.localidade],
      telefone: this.fb.array(tels.map(t => new FormControl(t))),
      especialidade: this.fb.array(esp.map(e => new FormControl(e))),
      validMed: [validMed],
      ConteudoMedFiltro: [filter],
      retorno_med: [medData.retorno_med || firstMatch.NOMBRE_MEDICO || ''],
      retorno_matricula: [medData.retorno_matricula || firstMatch.MATRICULA1 || ''],
      retorno_matricula1: [medData.retorno_matricula1 || firstMatch.MATRICULA2 || ''],
      retorno_matricula2: [medData.retorno_matricula2 || firstMatch.MATRICULA3 || ''],
      retorno_esp1: [medData.retorno_esp1 || firstMatch.ESPECIALIDAD || ''],
      retorno_esp2: [medData.retorno_esp2 || firstMatch.ESPECIALIDAD2 || ''],
      retorno_esp3: [medData.retorno_esp3 || firstMatch.ESPECIALIDAD3 || ''],
      retorno_direccion: [medData.retorno_direccion || firstMatch.DIRECCION || ''],
      retorno_localid: [medData.retorno_localid || firstMatch.LOCALIDAD || ''],
      nro_medico: [medData.nro_medico || ''],
      retorno_nro_medico: [medData.retorno_nro_medico || firstMatch.NRO_MEDICO || ''],
      interaccion_del_usuario: [medData.interaccion_del_usuario || ''],
      
      nome_medico_original: [medData.nome_medico_original || medData.nome || ''],
      nome_medico_salvo: [medData.nome_medico_salvo || ''],
      
      matricula1_original: [medData.matricula1_original || medData.matricula || ''],
      matricula1_salvo: [medData.matricula1_salvo || ''],
      matricula2_original: [medData.matricula2_original || ''],
      matricula2_salvo: [medData.matricula2_salvo || ''],
      matricula3_original: [medData.matricula3_original || ''],
      matricula3_salvo: [medData.matricula3_salvo || ''],
      
      especialidade1_original: [medData.especialidade1_original || esp[0] || ''],
      especialidade1_salvo: [medData.especialidade1_salvo || ''],
      especialidade2_original: [medData.especialidade2_original || esp[1] || ''],
      especialidade2_salvo: [medData.especialidade2_salvo || ''],
      especialidade3_original: [medData.especialidade3_original || esp[2] || ''],
      especialidade3_salvo: [medData.especialidade3_salvo || ''],
      
      endereco_original: [medData.endereco_original || medData.rua || ''],
      endereco_salvo: [medData.endereco_salvo || ''],
      localidade_original: [medData.localidade_original || medData.localidade || ''],
      localidade_salvo: [medData.localidade_salvo || '']
    });
  }

  private parseConteudoFiltro(value: any): any[] {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      try { return JSON.parse(value); } catch { return []; }
    }
    return [];
  }
  createInstituicao(d: any = {}) {
    const instData = d['0'] || d[0] || d || {};
    const validInst = d.validInst ?? instData.validInst ?? false;
    const conteudoInst = d.conteudoInst ?? instData.conteudoInst ?? instData.ConteudoInstFiltro;

    const tels = [...(instData.telefone || []), '', ''].slice(0, 2);
      
    const filter = this.parseConteudoFiltro(conteudoInst);
    const firstMatch = filter[0] || {};

    return this.fb.group({
        nomeInstituicao: [instData.nomeInstituicao],
        email: [instData.email],
        rua: [instData.rua],
        localidade: [instData.localidade],
        codigoPostal: [instData.codigoPostal],
        cdgCiudad: [instData.cdgCiudad],
        nro_instit: [instData.nro_instit],
        telefone: this.fb.array(tels.map(t => new FormControl(t))),
        validInst: [validInst],
        ConteudoInstFiltro: [filter],
        interaccion_del_usuario: [instData.interaccion_del_usuario || ''],
        retorno_nome: [instData.retorno_nome || firstMatch.nombre_institucion || ''],
        retorno_rua: [instData.retorno_rua || firstMatch.direccion || ''],
        retorno_cidade: [instData.retorno_cidade || firstMatch.localidad || ''],
        retorno_cep: [instData.retorno_cep || firstMatch.cp || ''],
        retorno_cdg_cidade: [instData.retorno_cdg_cidade || firstMatch.cdg_ciudad || ''],
        retorno_nro_instit: [instData.retorno_nro_instit || firstMatch.nro_instit || ''],
        // Nome lido pela IA, setado uma unica vez aqui: nomeInstituicao e sobrescrito na selecao
        // da ambiguidade/pesquisa (institution-form-pending), entao o original precisa ser
        // preservado antes disso.
        nome_instituicao_original: [instData.nome_instituicao_original || instData.nomeInstituicao || '']
    });
  }
  validarEntrada(event: KeyboardEvent) {
    const caracteresProibidos = ['|', ',', ';'];
    if (caracteresProibidos.includes(event.key)) {
      event.preventDefault();
    }
  }

  // ------------ Atalhos teclado -----------------
  // @HostListener('window:keydown', ['$event'])
  // handleKeyboardEvent(e: KeyboardEvent) {
  //   if (!e.altKey || !this.doShortcutActive) return; e.preventDefault();
  //   ({ Enter: () => this.ok(), P: () => this.nextPrescription(),
  //      p: () => this.nextPrescription(), A: () => this.prescriptionBack(),
  //      a: () => this.prescriptionBack(), C: () => this.toggleCollapsedImage(),
  //      c: () => this.toggleCollapsedImage(), Backspace: () => this.backSpace()
  //   }[e.key]?.());
  // }

@HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(e: KeyboardEvent) {
  // ---- SHIFT + SETA PARA BAIXO / CIMA → navegar produtos ----
  if (e.shiftKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
    e.preventDefault();
    this.focusNextField(e.key === 'ArrowDown' ? +1 : -1);
    return;
  }

    // ---- Atalhos ALT existentes ----
    if (!e.altKey || !this.doShortcutActive) return;

    e.preventDefault();

    ({
      Enter: () => this.ok(),
      P: () => this.nextPrescription(),
      p: () => this.nextPrescription(),
      A: () => this.prescriptionBack(),
      a: () => this.prescriptionBack(),
      C: () => this.toggleCollapsedImage(),
      c: () => this.toggleCollapsedImage(),
      Backspace: () => this.backSpace(),
    }[e.key]?.());
  }

 private focusNextField(direction: 1 | -1 = 1): void {
  const activeElement = document.activeElement as HTMLElement | null;
  if (!activeElement) return;

  // --- REGRA ESPECÍFICA: SHIFT+↓/↑ em nome/posologia -> "nome" do próximo/anterior produto ---
  const fc = activeElement.getAttribute?.('formcontrolname');
  if (fc === 'nome' || fc === 'posologia') {
    const container = activeElement.closest('.product_data__items_scroll') as HTMLElement | null;

    if (container) {
      // Linhas do produto: .flex que contém input nome
      const rows = Array.from(container.querySelectorAll<HTMLElement>('.flex'))
        .filter(r => !!r.querySelector('input[formcontrolname="nome"]'));

      const currentRowIndex = rows.findIndex(r => r.contains(activeElement));

      if (currentRowIndex >= 0) {
        const start = currentRowIndex + direction;

        if (direction === 1) {
          for (let i = start; i < rows.length; i++) {
            const nextNome = rows[i].querySelector<HTMLElement>('input[formcontrolname="nome"]');
            if (nextNome && !nextNome.hasAttribute('disabled') && nextNome.offsetParent !== null) {
              nextNome.focus();
              return;
            }
          }
        } else {
          for (let i = start; i >= 0; i--) {
            const prevNome = rows[i].querySelector<HTMLElement>('input[formcontrolname="nome"]');
            if (prevNome && !prevNome.hasAttribute('disabled') && prevNome.offsetParent !== null) {
              prevNome.focus();
              return;
            }
          }
        }
      }
    }

    // Se não achou anterior/próximo, pode só cair no fluxo normal abaixo
    // (ou dar return se você quiser bloquear o fallback)
  }

  // --- DAQUI PRA BAIXO: mantém seu comportamento original (diagnóstico / imageQuality / etc) ---
  // ... seu código existente ...
}

  addDiagnostico() {
    this.diagnosticos.push(new FormControl(''));
  }

  removerDiagnostico(index: number) {
    if (this.diagnosticos.length > 2) {
      this.diagnosticos.removeAt(index);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  aoFecharOuRecarregar() {
    this.chamarApiAoSair();
  }

  // ------------ Modais -----------------
  openModal() {
    this.isModalOpen = true;
  }
  closeModal(shortcut = false) {
    this.isModalOpen = false;
    if (shortcut) this.doShortcutActive = true;
  }
  closeModal1() {
    this.isModal1Open = false;
  }

  public readCountryVisibleFieldsPrescription(id: string) {
    this.json.readCountry(id).subscribe(
      resp => {
        if (resp.visiblePrescriptionFields != null) {
          this.isVisibleDiagnostico =  resp.visiblePrescriptionFields.includes("diagnostico");
          this.isVisibleInstituicao =  resp.visiblePrescriptionFields.includes("nomeInstituicao");
          this.isVisibleEnderecoinstituicao =  resp.visiblePrescriptionFields.includes("enderecoInstituicao");
          this.isVisibleNomeMedico =  resp.visiblePrescriptionFields.includes("nomeMedico");
          this.isVisibleEnderecoMedico =  resp.visiblePrescriptionFields.includes("enderecoMedico");
          this.isVisibleEspecialidadeMedico =  resp.visiblePrescriptionFields.includes("especialidade");
          this.isVisibleProduto =  resp.visiblePrescriptionFields.includes("produto");

          this.codigoPaisMaestro = resp.codigoMaestro || '';
        } else {
          console.log("O campo 'diagnostico' não está presente.");
        }
      },
      erro => {
        this.logger.error('Erro ao ler campo visibleFiledsPrescricao', erro);
      }
    );
  }

  private getCodigoRegiaoById(id: string): string {
    const regiao = this.listaRegiao.find(r => r.id === id);
    return regiao ? regiao.codigo : '';
  }


confirmRecusaEnter(event: KeyboardEvent, trigger: MatAutocompleteTrigger): void {
  event.preventDefault();
  event.stopPropagation();

  const ctrl = this.form?.get('notReconize');
  if (!ctrl) return;

  // 1) Se o painel está aberto e tem opção ativa, seleciona ela
  if (trigger?.panelOpen) {
    const active = (trigger as any).activeOption; // activeOption não é tipado em algumas versões
    if (active) {
      active.select();          // dispara optionSelected e escreve no input
      trigger.closePanel();
      return;
    }
  }

  const raw = (ctrl.value ?? '').toString();
  const term = this.normalize(raw);

  // 2) Match exato por code OU name (digitou e apertou enter)
  const found = this.infoNotRecognizedOptions.find((x: any) => {
    const code = this.normalize(x.code);
    const name = this.normalize(x.name);
    return code === term || name === term;
  });

  if (found) {
    ctrl.setValue(found.name, { emitEvent: true }); // mantém seu padrão: salva o name (string)
    trigger?.closePanel();
    return;
  }

  // 3) Se sobrou 1 opção no filtro, assume ela
  if (this.infoNotRecognizedFiltred?.length === 1) {
    ctrl.setValue(this.infoNotRecognizedFiltred[0].name, { emitEvent: true });
    trigger?.closePanel();
    return;
  }

  // Se não encontrou nada, só fecha o painel (mantém o texto digitado)
  trigger?.closePanel();
}



  cancelarRevisao(): void {
    this.logger.info('Revisão cancelada pelo usuário.');
    
    // Reverte todas as ações de entrada de dados limpando o formulário atual
    this.resetAllContent();
    
    // Fecha o modal e avança para a próxima receita (o destravamento ocorre dentro de nextPrescription)
    this.closeModal(true);
    this.nextPrescription();
  }

}
